import axios from 'axios';

// The demo endpoint only exists on the FastAPI backend (exposed via the
// api.globalnow.biz Cloudflare tunnel) — there's no Netlify Function fallback
// for it the way MrSupport's /api/ai/support/chat has, so we call it directly
// rather than relying on REACT_APP_BACKEND_URL possibly resolving to a
// relative path that Netlify would 404 on.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://api.globalnow.biz';

// Calls the anonymous, free-tier /api/ai/demo endpoint used by the landing-page
// "try it now" widgets. Nothing sent here is stored server-side.
export async function callDemo(widget, payload) {
  const response = await axios.post(`${BACKEND_URL}/api/ai/demo`, {
    widget,
    ...payload,
  });
  return response.data;
}

export function demoErrorMessage(err) {
  return (
    err?.response?.data?.detail ||
    'Could not reach the demo right now — try again in a moment.'
  );
}
